import { all } from "redux-saga/effects";
import { emailConfigSaga } from "./emailConfigSaga";
import { emailFormSaga } from "./emailFormSaga";
import { emailTemplateSaga } from "./emailTemplateSaga";

export default function* emailSagaWrapper() {

    yield all([
        emailConfigSaga(),
        emailTemplateSaga(),
        emailFormSaga()
    ]);
}
